import ActionTypeZona from "../ActionTypeZona";

export default class BuscarZonas extends ActionTypeZona{
    ejecutar(estado, nuevoEstado) {    
        nuevoEstado.flag.procesandoComando = true;
        nuevoEstado.flag.procesandoComandoBuscarAll = true;
        // nuevoEstado.flag.sensorDeAccionABuscar = !(estado.flag.sensorDeAccionABuscar);
        return nuevoEstado;
    }
}